import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import leadService from "./leadsService";

const initialState = {
    leads: null,
    search: null,
    singleLead: null,
    isError: false,
    isSuccess: false,
    isLodaing: false,
    massage: "",
};

export const getAllLeads = createAsyncThunk(
    "leads/get",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await leadService.getAllLeads(data,token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const getSingleLead = createAsyncThunk(
    "leads/single",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await leadService.getSingleLead(id, token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const SearchOnLeadsAction = createAsyncThunk(
    "leads/search",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await leadService.LeadSearch(data, token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const updateLead = createAsyncThunk(
    "leads/update",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await leadService.updateLead(data, token);
        } catch (error) {
            const message = error.message;
            return thunkAPI.rejectwithValue(message);
        }
    }
);

export const leadsSlice = createSlice({
    name: "leads",
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLodaing = false;
            state.massage = "";
        },
        leadSearchAction: (state, action) => {
            state.search = action.payload;
        },
    },
    extraReducers: {
        //getAllLeads Actions
        [getAllLeads.pending]: (state) => {
            state.isLodaing = true;
        },
        [getAllLeads.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.leads = action.payload;
            state.isSuccess = true;
        },
        [getAllLeads.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        // Search On Leads
        [SearchOnLeadsAction.pending]: (state) => {
            state.isLodaing = true;
        },
        [SearchOnLeadsAction.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.leads = action.payload;
            state.isSuccess = true;
        },
        [SearchOnLeadsAction.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },
        //getSingle Lead Actions
        [getSingleLead.pending]: (state) => {
            state.isLodaing = true;
        },
        [getSingleLead.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.singleLead = action.payload;
            state.isSuccess = true;
        },
        [getSingleLead.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //getSingle Lead Actions
        [updateLead.pending]: (state) => {
            state.isLodaing = true;
        },
        [updateLead.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [updateLead.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },
    },
});

export const { reset, leadSearchAction } = leadsSlice.actions;
export default leadsSlice.reducer;
